export default (
  state = {
    activePipeline: {},
    activeTemplates: [],
    cards: {}, // Contains swimlane cards info specific to a pipeline
    cloneCards: {},
    pageNumber: 1,
    pipelineSearchTerm: "",
    pipelines: [], // Holds all piplines associated with the orfg
    routingRules: [],
    swimLaneCardsCount: [],
    swimLaneEvents: [],
    swimLanes: [], // Contains swimlane columns specific to a pipeline
    swimLaneList: {},

    // Lane job related keys
    laneJobs: [],
    // Reminders related keys
    reminderSettings: [],
  },
  action,
) => {
  switch (action.type) {
    /*
    ===============================
        Pipeline Init Data
    ===============================
    */
    case "GET_PIPELINES_LIST":
      return {
        ...state,
        pipelines: action.payload,
      };
    case "GET_PIPELINE_DATA_BY_ID":
      return {
        ...state,
        swimLanes: action.payload.swimLanes,
        cards: action.payload.cards,
        swimLaneEvents: action.payload.swimLaneEvents,
        swimLaneCardsCount: action.payload.swimLaneCardsCount,
        activePipeline: action.payload.activePipeline,
      };
    case "GET_DOC_CARDS_BY_SWIMLANES":
      return {
        ...state,
        cards: {
          ...state.cards,
          [action.payload.laneId]: {
            cardDetails: [...action.payload.data],
            hasMore: action.payload.hasMore,
            pageNumber: action.payload.pageNumber,
          },
        },
        cloneCards: {
          ...state.cards,
          [action.payload.laneId]: {
            cardDetails: [...action.payload.data],
            hasMore: action.payload.hasMore,
            pageNumber: action.payload.pageNumber,
          },
        },
      };
    case "GET_PIPELINE_LANE_VALUE":
      return {
        ...state,
        swimLaneList: { ...state.swimLaneList, ...action.payload },
      };

    case "GET_PIPELINE_CARDS_COUNT":
      return {
        ...state,
        swimLaneCardsCount: action.payload,
      };

    case "UPDATE_SWIMLANE_DRAG_DROP": {
      const { dataFrom, dataTo, draggableData } = action.payload;
      const { cards } = state;
      const source = cards[dataFrom].cardDetails;
      const newSwimLaneDetails = cards[dataFrom].cardDetails.filter(
        item => item.doc_no === draggableData,
      );
      const destination = cards[dataTo].cardDetails;
      const newdata = source.filter(item => item.doc_no !== draggableData);

      return {
        ...state,
        cards: {
          ...state.cards,
          [dataFrom]: {
            cardDetails: newdata,
            hasMore: action.payload.hasMore,
            pageNumber: action.payload.pageNumber,
          },
          [dataTo]: {
            cardDetails: [newSwimLaneDetails[0], ...destination],
            hasMore: action.payload.hasMore,
            pageNumber: action.payload.pageNumber,
          },
        },
      };
    }

    case "ADD_NEW_LANE_TRANSITIONS": {
      return {
        ...state,
        swimLanes: action.payload,
      };
    }
    case "PIPELINE_SEARCH_TERM":
      return {
        ...state,
        pipelineSearchTerm: action.payload,
      };
    case "UPDATE_LANE_EVENTS": {
      const { swimLanes } = state;
      swimLanes.forEach(item => {
        if (item.id === action.payload.id) {
          item.transition_events = action.payload.transition_events;
        }
      });
      return {
        ...state,
        swimLanes,
      };
    }
    case "DELETE_LANE_TANSITION": {
      const { swimLanes } = state;
      const newSwimLane = swimLanes.filter(
        item => item.id !== action.payload.laneID,
      );
      return {
        ...state,
        swimLanes: newSwimLane,
      };
    }
    case "UPDATE_LANE_ORDERING": {
      return {
        ...state,
        swimLanes: action.payload.data,
      };
    }
    case "DELETE_SWIMLANE_CONFIG_TRANSACTION": {
      const { swimLanes } = state;
      swimLanes.forEach(item => {
        if (item.id === action.payload.updatedLane.id) {
          item = action.payload.updatedLane;
        }
      });
      return {
        ...state,
        swimLanes,
      };
    }
    case "UPDATE_SWIMLANE_CONFIG_TRANSACTION": {
      return {
        ...state,
        swimLanes: action.payload,
      };
    }
    case "PIPELINE_DOCS": {
      return {
        ...state,
        cards: action.payload,
      };
    }
    case "ADD_NEW_PIPELINE": {
      return {
        ...state,
        pipelines: [...state.pipelines, action.payload],
      };
    }
    case "EDIT_PIPELINE": {
      const updatedActivePipeline =
        state.activePipeline.id === action.payload.id
          ? {
              id: action.payload.id,
              name: action.payload.name,
              isDefault: action.payload.isDefault || false,
            }
          : state.activePipeline;

      return {
        ...state,
        pipelines: state.pipelines.map(pipeline =>
          pipeline.id === action.payload.id ? action.payload : pipeline,
        ),
        activePipeline: updatedActivePipeline,
      };
    }
    case "DELETE_PIPELINE": {
      const updatedPipelines = state.pipelines.filter(
        item => item.id !== action.payload.id,
      );
      return {
        ...state,
        pipelines: updatedPipelines,
      };
    }
    case "MOVE_DOC_TO_ANOTHER_PIPELINE": {
      const { laneId } = action.payload;

      const updatedCardsInfo = state.cards[laneId].cardDetails.filter(
        card => card.id !== action.payload.docId,
      );

      return {
        ...state,
        cards: {
          ...state.cards,
          [laneId]: {
            ...state.cards[laneId],
            cardDetails: updatedCardsInfo,
          },
        },
      };
    }
    case "GET_PIPELINE_ROUTING_RULES": {
      return {
        ...state,
        routingRules: action.payload,
      };
    }
    case "GET_ACTIVE_TEMPLATES_FOR_ROUTING_RULES": {
      return {
        ...state,
        activeTemplates: action.payload,
      };
    }
    case "ADD_ROUTING_RULE": {
      return {
        ...state,
        routingRules: [...action.payload, ...state.routingRules],
      };
    }

    case "DELETE_ROUTING_RULE": {
      const updatedRoutingRule = state.routingRules.filter(
        rule => rule.id !== action.payload,
      );
      return {
        ...state,
        routingRules: updatedRoutingRule,
      };
    }
    case "NUKE_PIPELINE_ROUTING_DATA": {
      return {
        ...state,
        routingRules: [],
        activeTemplates: [],
      };
    }
    case "CREATE_PIPELINE_LANE_JOB": {
      return {
        ...state,
        laneJobs: action.payload,
      };
    }
    case "UPDATE_PIPELINE_LANE_JOB": {
      return {
        ...state,
        laneJobs: action.payload,
      };
    }
    case "INIT_PIPELINE_LANE_JOBS": {
      return {
        ...state,
        laneJobs: action.payload,
      };
    }
    case "DELETE_PIPELINE_LANE_JOB": {
      return {
        ...state,
        laneJobs: action.payload,
      };
    }
    case "GET_PIPELINE_REMINDER_EVENTS":
      return {
        ...state,
        reminderSettings: action.payload,
      };
    default:
      return state;
  }
};
